const awsmobile =  {
    "aws_appsync_graphqlEndpoint": "https://f5agzri7knetzjocfwacnzvv7i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-sfxxtuydrfadfgqqjhoqvnux3i",

};

export default awsmobile;